import { useEffect, useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { StatCard } from "../../components/shared";
import { toast } from "sonner";

export default function Reports() {
  const { user } = useAuth();
  const [report, setReport] = useState(null);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (user?.role === "super_admin") {
      api.get("/admin/financial-report").then((r) => setReport(r.data)).catch((e) => toast.error(fmtErr(e)));
    }
    api.get("/admin/audit-logs").then((r) => setLogs(r.data));
  }, [user]);

  return (
    <div data-testid="reports-page">
      <h1 className="text-3xl font-bold tracking-tight text-neutral-900 font-heading mb-8">Reports</h1>

      {user?.role === "super_admin" && report && (
        <>
          <h2 className="text-xl font-semibold font-heading mb-4">Financial summary</h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            <StatCard testId="report-service-revenue" label="Service revenue" value={`$${report.service_revenue.toLocaleString()}`} sub={`${report.paid_transactions} paid transactions`} />
            <StatCard testId="report-total-royalties" label="Total royalties" value={`$${report.total_royalties.toLocaleString()}`} sub={`${report.total_units} units sold`} />
            <StatCard testId="report-author-share" label="Author share" value={`$${report.author_share.toLocaleString()}`} />
            <StatCard testId="report-company-share" label="Company share" value={`$${report.company_share.toLocaleString()}`} />
          </div>
          <div className="grid grid-cols-3 gap-4 mb-10">
            <StatCard label="Total projects" value={report.projects_total} />
            <StatCard label="Live on Amazon" value={report.projects_live} />
            <StatCard label="Authors" value={report.authors_total} />
          </div>
        </>
      )}

      <h2 className="text-xl font-semibold font-heading mb-4">Audit trail</h2>
      <div className="bg-white border border-neutral-200 rounded-lg overflow-hidden">
        <div className="overflow-x-auto"><table className="min-w-full divide-y divide-neutral-200 text-sm text-left">
          <thead><tr className="bg-neutral-50">
            {["When", "Actor", "Action", "Entity", "Details"].map((h) => (
              <th key={h} className="px-6 py-3 font-medium text-neutral-500 uppercase tracking-wider text-xs">{h}</th>))}
          </tr></thead>
          <tbody className="divide-y divide-neutral-100">
            {logs.map((l) => (
              <tr key={l.id} data-testid={`audit-row-${l.id}`}>
                <td className="px-6 py-3 whitespace-nowrap">{new Date(l.created_at).toLocaleString()}</td>
                <td className="px-6 py-3">{l.actor_email}</td>
                <td className="px-6 py-3 font-medium">{l.action}</td>
                <td className="px-6 py-3 text-neutral-500">{l.entity_type}</td>
                <td className="px-6 py-3 text-xs text-neutral-500 max-w-xs truncate">{JSON.stringify(l.details)}</td>
              </tr>
            ))}
            {logs.length === 0 && <tr><td colSpan={5} className="px-6 py-6 text-neutral-400">No audit entries yet.</td></tr>}
          </tbody>
        </table></div>
      </div>
    </div>
  );
}
